import React from 'react';
import PropTypes from 'prop-types';
import StatusPill from './pill/StatusPill';

const STATUS_CONFIG = {
  active: {
    label: 'Active',
    tone: 'success',
    title: 'User has accepted their invitation and can sign in.',
  },
  pending: {
    label: 'Pending',
    tone: 'warning',
    title: 'Invitation sent but not yet accepted.',
  },
  deactivated: {
    label: 'Deactivated',
    tone: 'neutral',
    title: 'User account has been deactivated.',
  },
};

function formatLabel(status) {
  if (!status) return 'Unknown';
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export default function UserAccountStatusBadge({ status, className }) {
  const config = STATUS_CONFIG[status?.toLowerCase()];

  if (!config) {
    return <StatusPill tone="neutral" className={className}>{formatLabel(status)}</StatusPill>;
  }

  return (
    <StatusPill tone={config.tone} title={config.title} className={className}>
      {config.label}
    </StatusPill>
  );
}

UserAccountStatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
};

UserAccountStatusBadge.defaultProps = {
  status: null,
  className: '',
};
